import styled from 'styled-components';

import { Svg } from '@spa/shared/components/Histogram/styles';
import { FilterCard } from '@spa/shared/components/Filters/styles';
import { Container as SliderContainer } from '@spa/shared/components/Slider/styles';
import { mediaMin } from '@spa/shared/theme';

export const Container = styled.div`
  ${FilterCard}

  flex-direction: column;
  height: auto;

  ${SliderContainer} {
    height: 3px;
  }

  ${Svg} {
    width: 100%;
  }
`;

export const Label = styled.label`
  display: flex;
  color: #667485;
  text-align: left;
  font-size: ${props => props.theme.rem(14)};
  font-family: IntervalNextReg, sans-serif;
`;

export const ValuesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: ${props => props.theme.space(4)};

  ${mediaMin.largeBreakpoint`
    flex-wrap: wrap;
    gap: ${props => props.theme.space(1)};
  `}
`;

export const ValuesSeparator = styled.span`
  width: 10px;
  height: 4px;
  background-color: ${props => props.theme.colors.shadyGray};
  margin: ${props => props.theme.space(0)} ${props => props.theme.space(3)};

  ${mediaMin.largeBreakpoint`
    display: none;
  `}
`;
